import useDataLayer from '@/hooks/useDataLayer/useDataLayer';
import { FormHTMLAttributes, useEffect } from 'react';

const Form = (
  props: FormHTMLAttributes<HTMLFormElement> & { name: string }
) => {
  const { pushDataLayerEvent } = useDataLayer();

  useEffect(() => {
    pushDataLayerEvent({
      event: 'Formular geöffnet',
      formName: props.name,
    });
  }, [props.name, pushDataLayerEvent]);

  return <form {...props} />;
};

export default Form;
